import React, { useContext, useCallback } from 'react'
import { m, LazyMotion, domAnimation } from "framer-motion"
import { MainContext } from "../../context/mainContext";
import { actionUrlConverter, alternateUrlConverter } from '../../util/util'
import { countdownBannerLabels, countdownBannerMap } from './constants'


export const HeroCatalogCounter = ({ countdownBannerList }) => {
    const ctx = useContext(MainContext)

    const countdownBannerOrderedData = countdownBannerMap.map(bannerMapPlace => {
		// filter banner map place based on availability of current banner type 
		const filteredBannerPlace = bannerMapPlace.filter(bannerType => countdownBannerList?.some(countdownDataRecord => countdownDataRecord.type === bannerType))

		return countdownBannerList?.find(countdownDataRecord => countdownDataRecord.type === filteredBannerPlace[0]);
	})
	// filter to drop empty banner places
	.filter(banner => banner)


    const cardClickHandler = useCallback(
        (e, catalog) => {
            e.stopPropagation()
            if (catalog.subCatalogs?.length) {
                ctx.openPopup({
                    class: 'small',
                    title: 'Select Your Collection',
                    content:<div className="list-group">
                                {
                                    catalog.subCatalogs.map( cat => <a key={cat.id} className="list-group-item" href={actionUrlConverter(cat.actionUrl)}><span>{cat.displayName}</span></a> )
                                }
                            </div>
                })
            } else {
                catalog.alternateUrl ? window.open(alternateUrlConverter(catalog.alternateUrl), '_blank', 'noopener,noreferrer') : window.open(actionUrlConverter(catalog.actionUrl), '_self')
            }
        },
        [],
    )

    return (
        <div className="countdown-banner-container">
            {countdownBannerOrderedData.map(countdownEl => (
                <LazyMotion features={domAnimation} key={countdownEl.type} >
                    <m.div
                        className="countdown-banner"
                        animate={{
                            y: [30, 0],
                            opacity: [0, 1],
                            transition: {
                                delay: 1.5,
                                duration: .5,
                            },
                        }}
                    >
                        {countdownEl.counterNumber === 0 &&
                            <div className="counter-container">
                                <div className="counter-text large-font">{countdownBannerLabels.counterText[countdownEl.type]['last']}</div>
                            </div>    
                        }
                        {countdownEl.counterNumber === 1 &&
                            <div className="counter-container">
                                <div className="counter">{countdownEl.counterNumber}</div>
                                <div className="counter-text large-font">{countdownBannerLabels.counterText[countdownEl.type]['singular']}</div>
                            </div>    
                        }
                        {countdownEl.counterNumber > 1 &&
                            <div className="counter-container">
                                <div className="counter">{countdownEl.counterNumber}</div>
                                <div className="counter-text">{countdownBannerLabels.counterText[countdownEl.type]['plural']}</div>
                            </div>
                        }
                        <div className="banner-message">
                            <div className="action-prompt">{countdownBannerLabels.actionPrompt[countdownEl.type]}</div>
                            <h5 className="display-name">{countdownBannerLabels.displayName[countdownEl.type]}</h5>
                        </div>
                        <div className="controls">
                            <a href='#' onClick={(e)=>{cardClickHandler(e, countdownEl.catalog)}} className="btn btn-primary">BUY NOW</a>
                        </div>
                    </m.div>
                </LazyMotion>
            ))}
        </div>
    )
    
}
